/* ========================================================================== 
   Nootrópicos México v70.9 — Neural Lens runtime
   Native, dependency-free, desktop-only and progressively enhanced.
   ========================================================================== */
(function () {
  "use strict";

  if (!window.matchMedia) return;

  var root = document.documentElement;
  var desktopMotion = window.matchMedia(
    "(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)",
  );
  var revealObserver = null;
  var mutationFrame = 0;

  var REVEAL_SELECTOR = [
    ".product-single__hero",
    ".nm-home-hero",
    ".nm-landing-ia",
    ".nm-trust-badges",
    ".section-header",
    ".grid-link__container > .grid__item",
    ".site-footer .grid__item",
    ".sidebar-module",
  ].join(",");

  /* Product cards keep their native, restrained hover state. The full pointer
     lens was visually overpowering product photography in dense collections. */
  var DEPTH_SELECTOR = [".nm-stack-card", ".nm-product-info-inline"].join(",");

  function motionAllowed() {
    return desktopMotion.matches;
  }

  function isExcluded(el) {
    return Boolean(
      el.closest(
        "#MobileNav,#nmCartDrawer,#nmChatWidget,.nm-chat-widget,.nm-product-lightbox",
      ),
    );
  }

  function createLightField() {
    var field = document.querySelector(".nm-v709-light-field");
    if (field) return field;
    field = document.createElement("div");
    field.className = "nm-v709-light-field";
    field.setAttribute("aria-hidden", "true");
    document.body.insertBefore(field, document.body.firstChild);
    return field;
  }

  function initAmbientField() {
    var field = createLightField();
    if (field.dataset.nmV709Ready === "true") return;
    field.dataset.nmV709Ready = "true";
    var pointerFrame = 0;
    var pointerX = 52;
    var pointerY = 24;

    function paintPointer() {
      pointerFrame = 0;
      field.style.setProperty("--nm-v709-field-x", pointerX.toFixed(2) + "%");
      field.style.setProperty("--nm-v709-field-y", pointerY.toFixed(2) + "%");
    }

    window.addEventListener(
      "pointermove",
      function (event) {
        if (!motionAllowed()) return;
        pointerX = Math.max(8, Math.min(92, (event.clientX / window.innerWidth) * 100));
        pointerY = Math.max(8, Math.min(88, (event.clientY / window.innerHeight) * 100));
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(paintPointer);
      },
      { passive: true },
    );
  }

  function addHeroOptic(scope) {
    var hero = scope.querySelector
      ? scope.querySelector(".product-single__hero,.nm-home-hero,.nm-hero")
      : null;
    if (!hero || hero.querySelector(":scope > .nm-v709-hero-optic")) return;
    var optic = document.createElement("span");
    optic.className = "nm-v709-hero-optic";
    optic.setAttribute("aria-hidden", "true");
    hero.appendChild(optic);
    hero.setAttribute("data-nm-v709-reveal", "hero");
  }

  function setLensPointer(card, event) {
    var rect = card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;
    var lens = card.querySelector(":scope > .nm-v709-lens");
    if (!lens) return;
    lens.style.setProperty("--nm-v709-lens-x", x.toFixed(2) + "%");
    lens.style.setProperty("--nm-v709-lens-y", y.toFixed(2) + "%");
  }

  function decorateCard(card) {
    if (!card || card.dataset.nmV709Depth === "true" || isExcluded(card)) return;
    card.dataset.nmV709Depth = "true";
    card.setAttribute("data-nm-v709-depth", "");

    var lens = document.createElement("span");
    lens.className = "nm-v709-lens";
    lens.setAttribute("aria-hidden", "true");
    card.appendChild(lens);

    var pointerFrame = 0;
    var lastEvent = null;
    card.addEventListener(
      "pointermove",
      function (event) {
        if (!motionAllowed()) return;
        lastEvent = event;
        if (pointerFrame) return;
        pointerFrame = window.requestAnimationFrame(function () {
          pointerFrame = 0;
          if (lastEvent) setLensPointer(card, lastEvent);
        });
      },
      { passive: true },
    );
    card.addEventListener(
      "pointerleave",
      function () {
        lens.style.setProperty("--nm-v709-lens-x", "50%");
        lens.style.setProperty("--nm-v709-lens-y", "38%");
      },
      { passive: true },
    );
  }

  function decorateCards(scope) {
    if (!scope.querySelectorAll) return;
    Array.prototype.forEach.call(scope.querySelectorAll(DEPTH_SELECTOR), decorateCard);
    if (scope.matches && scope.matches(DEPTH_SELECTOR)) decorateCard(scope);
  }

  function revealNow(el) {
    el.classList.add("is-revealed");
    if (revealObserver) revealObserver.unobserve(el);
  }

  function registerReveal(el, index) {
    if (!el || el.dataset.nmV709RevealReady === "true" || isExcluded(el)) return;
    el.dataset.nmV709RevealReady = "true";
    if (!el.hasAttribute("data-nm-v709-reveal")) {
      el.setAttribute("data-nm-v709-reveal", "section");
    }
    el.style.setProperty("--nm-v709-delay", Math.min(index % 8, 7) * 42 + "ms");

    if (!motionAllowed()) {
      revealNow(el);
      return;
    }
    if (!revealObserver) {
      /* Secciones montadas después también deben quedar visibles sin IO. */
      revealNow(el);
      return;
    }
    if (
      root.classList.contains("nm-v709-motion-ready")
    ) {
      revealObserver.observe(el);
    }
  }

  function registerReveals(scope) {
    if (!scope.querySelectorAll) return;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(REVEAL_SELECTOR));
    if (scope.matches && scope.matches(REVEAL_SELECTOR)) nodes.unshift(scope);
    nodes.forEach(registerReveal);
  }

  function prepareScope(scope) {
    addHeroOptic(scope);
    decorateCards(scope);
    registerReveals(scope);
  }

  function initObserver() {
    if (!("IntersectionObserver" in window)) return;
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) revealNow(entry.target);
        });
      },
      { rootMargin: "0px 0px -5% 0px", threshold: 0.06 },
    );
  }

  function activateMotion() {
    if (!motionAllowed()) {
      root.classList.remove("nm-v709-motion-ready");
      Array.prototype.forEach.call(
        document.querySelectorAll("[data-nm-v709-reveal]"),
        revealNow,
      );
      return;
    }

    if (!revealObserver) initObserver();
    initAmbientField();
    prepareScope(document);

    /* Mejora progresiva: sin IntersectionObserver nunca ocultamos contenido. */
    if (!revealObserver) {
      root.classList.add("nm-v709-motion-ready");
      Array.prototype.forEach.call(
        document.querySelectorAll("[data-nm-v709-reveal]"),
        revealNow,
      );
      return;
    }

    window.requestAnimationFrame(function () {
      root.classList.add("nm-v709-motion-ready");
      window.requestAnimationFrame(function () {
        Array.prototype.forEach.call(
          document.querySelectorAll("[data-nm-v709-reveal]"),
          function (el) {
            var rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
              revealNow(el);
            } else if (revealObserver) {
              revealObserver.observe(el);
            }
          },
        );
      });
    });
  }

  function scheduleRefresh() {
    if (mutationFrame) return;
    mutationFrame = window.requestAnimationFrame(function () {
      mutationFrame = 0;
      if (motionAllowed()) prepareScope(document);
    });
  }

  function init() {
    activateMotion();

    if (window.MutationObserver) {
      var main = document.querySelector("main") || document.body;
      new MutationObserver(scheduleRefresh).observe(main, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener("shopify:section:load", function (event) {
      if (motionAllowed()) prepareScope(event.target || document);
    });

    if (desktopMotion.addEventListener) {
      desktopMotion.addEventListener("change", activateMotion);
    } else if (desktopMotion.addListener) {
      desktopMotion.addListener(activateMotion);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
